import options from './member-details.component';

export default {
    selector: 'dtProjectMemberDetailsPage',
    options
};
